export enum IRelationshipTypesEnum {
  Employee = 'EMPLOYEE',
  Responsible = 'RESPONSIBLE',
}
